import * as S from "./styles";
import itauImage from "assets/images/itau.png";
import bradescoImage from "assets/images/bradesco.png";
import banestesImage from "assets/images/banestes.png";
import santanderImage from "assets/images/santander.png";
import caixaImage from "assets/images/caixa.png";
import bancoDoBrasilImage from "assets/images/banco-do-brasil.png";
import brbImage from "assets/images/brb.png";
import interImage from "assets/images/inter.png";

export const WrapperBanks = () => {
  return (
    <>
      <S.Title>Compare as taxas dos principais bancos:</S.Title>
      <S.ContainerBanks>
        <S.BankItem>
          <img src={itauImage} alt="Logo Itaú" />
          <div>
            <strong>Itaú</strong>
            <p>A partir de 12,09% a.a. efetiva.</p>
          </div>
        </S.BankItem>
        <S.BankItem>
          <img src={bradescoImage} alt="Logo Bradesco" />
          <div>
            <strong>Bradesco</strong>
            <p>A partir de 12,19% a.a. efetiva.</p>
          </div>
        </S.BankItem>
        <S.BankItem>
          <img src={banestesImage} alt="Logo Banestes" />
          <div>
            <strong>Banestes</strong>
            <p>A partir de 12,00% a.a. efetiva.</p>
          </div>
        </S.BankItem>
        <S.BankItem>
          <img src={santanderImage} alt="Logo Santander" />
          <div>
            <strong>Santander</strong>
            <p>A partir de 11,99% a.a. efetiva.</p>
          </div>
        </S.BankItem>
        <S.BankItem>
          <img src={caixaImage} alt="Logo Caixa Econômica" />
          <div>
            <strong>Caixa Econômica</strong>
            <p>A partir de 11,19% a.a. efetiva.</p>
          </div>
        </S.BankItem>
        <S.BankItem>
          <img src={bancoDoBrasilImage} alt="Logo Banco do Brasil" />
          <div>
            <strong>Banco do Brasil</strong>
            <p>A partir de 9,00% ** a.a. efetiva.</p>
          </div>
        </S.BankItem>
        <S.BankItem>
          <img src={brbImage} alt="Logo BRB" />
          <div>
            <strong>BRB</strong>
            <p>A partir de 11,34% a.a. efetiva.</p>
          </div>
        </S.BankItem>

        <S.BankItem>
          <img src={interImage} alt="Logo Inter" />
          <div>
            <strong>Inter</strong>
            <p>A partir de 114,00% a.a. efetiva.</p>
          </div>
        </S.BankItem>
      </S.ContainerBanks>
    </>
  );
};
